
























import { defineComponent, toRefs, PropType, computed, ref, nextTick } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import { useAdgroupMode } from '@tt4b/ttam-hooks';
import SavedAudienceSelect from './index';
import { trackEvent } from './../../../utils/index';
const name = 'ttam-saved-audience-select-compose';
export default defineComponent({
  name,
  components: {
    TtamSavedAudienceSelectSubcpn: SavedAudienceSelect.TtamSavedAudienceSelectSubcpn,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    savedAudienceConfig: {
      type: Object,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, savedAudienceConfig, createMode } = toRefs(props);
    const { loadData } = SavedAudienceSelect.useDataSource();
    const { savedAudienceOptions, savedAudienceOptionsPopoverContent } = SavedAudienceSelect.useSavedAudienceOptions({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const { isSavedAudienceVisible } = SavedAudienceSelect.usePropsSavedAudienceVisible({
      adgroupData,
      campaignData,
      createMode,
    });
    const { isEdit } = useAdgroupMode({ createMode });
    const disabledSavedAudience = computed(() => isEdit.value);
    const { handleSavedAudienceBackfill } = SavedAudienceSelect.useSavedAudienceBackfill({
      savedAudienceConfig,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    const savedAudienceId = computed(() => adgroupData.value.savedAudienceId);

    const onChange = async value => {
      const { backfillStatus, backfillFormData, finaleSavedAudienceId } = await handleSavedAudienceBackfill({
        savedAudienceId: value,
      });

      emit('on-backfill', {
        savedAudienceId: finaleSavedAudienceId,
        backfillFormData,
      });
      trackEvent('import_saved_audience_select', {
        is_success: backfillStatus,
        saved_audience_id: finaleSavedAudienceId,
      });
    };

    loadData();

    const { viewSavedAudienceDetail } = SavedAudienceSelect.useViewSavedAudienceDetail();

    return {
      name,
      savedAudienceOptions,
      savedAudienceId,
      disabledSavedAudience,
      isSavedAudienceVisible,
      onChange,
      viewSavedAudienceDetail,
      savedAudienceOptionsPopoverContent,
    };
  },
});
